import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

function CustomModal({
  open = false,
  setOpen,
  title = "",
  component: Component,
  componentProps = {},
  width = "520px",
}) {
  const handleClose = () => {
    if (typeof setOpen === "function") {
      setOpen(false);
    }
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: width,
          borderRadius: 2.5,
        },
      }}
    >
      {title ? <DialogTitle>{title}</DialogTitle> : null}
      <DialogContent dividers>
        {Component ? <Component setOpen={setOpen} {...componentProps} /> : null}
      </DialogContent>
    </Dialog>
  );
}

export default CustomModal;
